<div class="kt-portlet kt-portlet--height-fluid">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                {{ allCarriesSummaryTable.title }}
            </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
            <a href="javascript:;" class="btn btn-primary" (click)="allCarriesSummaryTable.reload()">
                <i class="fa fa-redo"></i> Refresh
            </a>
        </div>
    </div>
    <div class="kt-portlet__body" [busyIf]="allCarriesSummaryTable.loading">
        <div id="region_statistics_content">
            <table class="table">
                <thead>
                    <tr>
                        <td *ngFor="let field of allCarriesSummaryTable.fields" class="m-widget11__label">
                            {{ field.localizeKey | localize }}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor=" let data of allCarriesSummaryTable.datas; let index = index ">
                        <td *ngFor="let field of allCarriesSummaryTable.fields">
                            <span *ngIf="field.key === 'courierName'">
                                {{ data[field.key] }}
                            </span>
                            <sla-status-ui (clicked)="fieldClick($event)" [data]="data" [field]="field" [dashboardKeyName]="'courierName'" *ngIf="field.type === 'object'"></sla-status-ui>
                            <a *ngIf="field.key !== 'courierName' && field.type !== 'object'" href="javascript:;" (click)="fieldClick({xFilter: data['courierName'], yFilter:field.localizeKey})">
                                {{ data[field.key] }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <sla-status-legend></sla-status-legend>
</div>